import React from 'react';

const Checkout = () => {
  return (
    <div className="mt-10 text-center">
      <h3>Please confirm your paymnent and checkout</h3>
    </div>
  );
};

export default Checkout;
